import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class PlaceholderText extends BaseOption {
  static userInterfaceComponent = {
    label: "Placeholder text",
    component: inspectorTools.SIMPLE_INPUT,
  };

  static defaultValue = "Write something amazing...";
}
